import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';

class GoalDropDown extends React.Component {
    // constructor() {
    //     super();
    //     this.state = {
    //         value: '',
    //         changingTimeout: 0,
    //         hasChanges: false
    //     };
    //     this.handleValueChange = this.handleValueChange.bind(this);
    //     this.handleOnBlur = this.handleOnBlur.bind(this);
    //     this.saveValue = this.saveValue.bind(this);
    // }

    // componentDidMount() {
    //     this.setState((state) => {
    //         return { value: this.props.value ? this.props.value.trim() : '' };
    //     })
    // }

    // componentDidUpdate(prevProps) {
    //     if (this.props.noteId !== prevProps.noteId ||
    //         this.props.entityKeyValue !== prevProps.entityKeyValue ||
    //         this.props.value !== prevProps.value
    //     ) {
    //         this.setState((state) => {
    //             return { value: this.props.value ? this.props.value.trim() : '', hasChanges: false };
    //         })
    //     }
    // }

    // handleValueChange(event) {
    //     if (this.state.changingTimeout) {
    //         clearTimeout(this.state.changingTimeout);
    //     }

    //     if (event.target.value.startsWith("*")) {
    //         // apply favorite goal
    //         let key = Object.keys(this.props.goalFavorites)
    //             .find(x => '* ' + this.props.goalFavorites[x].GFNAME === event.target.value);
    //         this.props.applyFavoriteGoal(this.props.noteId, this.props.entityKeyValue, this.props.goalFavorites[key].GFNO);
    //     } else {
    //         this.setState({
    //             value: event.target.value,
    //             hasChanges: true,
    //             changingTimeout: setTimeout(() => this.saveValue(), 2000)
    //         });
    //     }
    // }

    // saveValue() {
    //     if (this.state.hasChanges) {
    //         if (this.state.value.trim() === '') {
    //             this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOMGNO');
    //             this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOCUSTOM');
    //         } else {
    //             let key = Object.keys(this.props.masterGoals)
    //                 .find(x => this.props.masterGoals[x].MGNAME === this.state.value);
    //             if (key === undefined) {
    //                 this.props.updateTextField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOCUSTOM', this.state.value);
    //                 this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOMGNO');
    //             } else {
    //                 this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOCUSTOM');
    //                 this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOMGNO', this.props.masterGoals[key].MGNO);
    //             }
    //         }
    //         this.setState({ hasChanges: false });
    //         if (this.props.onChange) {
    //             this.props.onChange();
    //         }
    //     }
    // }

    // handleOnBlur() {
    //     this.saveValue();
    //     clearTimeout(this.state.changingTimeout);
    // }

    updateField(event) {
        let key = undefined;
        if (event.target.value.startsWith("*")) {
            key = Object.keys(this.props.goalFavorites)
                .find(x => '* ' + this.props.goalFavorites[x].GFNAME === event.target.value);
            this.props.applyFavoriteGoal(this.props.noteId, this.props.entityKeyValue, this.props.goalFavorites[key].GFNO);
        } else {
            key = Object.keys(this.props.masterGoals)
                .find(x => this.props.masterGoals[x].MGNAME === event.target.value);
            if (key === undefined) {
                this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOMGNO');
            } else {
                this.props.updateIntField(this.props.noteId, 'PTGOALS', 'GONO', this.props.entityKeyValue, 'GOMGNO', this.props.masterGoals[key].MGNO);
            }
        }
        if (this.props.onChange) {
            this.props.onChange({ ...event, key });
        }
    }



    render() {
        return (
            <span>
                <select
                    title={this.props.title}
                    value={this.props.value ? this.props.value : -1}
                    name='GOMGNO'
                    className={this.props.className}
                    disabled={this.props.disabled}
                    onChange={(event) => this.updateField(event)}
                >
                    <option key={-1} value={-1}></option>
                    {Object.keys(this.props.goalFavorites)
                        .map(key => {
                            const result = this.props.goalFavorites[key];
                            return (
                                <option key={-1 * result.GFNO} value={'* ' + result.GFNAME} >{'* ' + result.GFNAME}</option>
                            )
                        })
                    }
                    {Object.keys(this.props.masterGoals)
                        .map(key => {
                            const result = this.props.masterGoals[key];
                            return (
                                <option key={result.MGNO} value={result.MGNAME} >{result.MGNAME}</option>
                            )
                        })
                    }
                </select>


                {/* 

                <input
                    className={this.props.className ? this.props.className : ''}
                    type="text"
                    title={this.props.title ? this.props.title : ''}
                    onChange={this.handleValueChange}
                    onBlur={this.handleOnBlur}
                    maxLength={this.props.maxLength ? this.props.maxLength : -1}
                    value={this.state.value}
                    disabled={this.props.disabled}
                    list='goalList' />
                <datalist id='goalList'>
                    {Object.keys(this.props.goalFavorites)
                        .map(key => {
                            const result = this.props.goalFavorites[key];
                            return (
                                <option key={-1 * result.GFNO} value={'* ' + result.GFNAME} />
                            )
                        })
                    }

                    {Object.keys(this.props.masterGoals)
                        .map(key => {
                            const result = this.props.masterGoals[key];
                            return (
                                <option key={result.MGNO} value={result.MGNAME} />
                            )
                        })
                    }
                </datalist> */}
            </span>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        applyFavoriteGoal: bindActionCreators(noteActions.applyFavoriteGoal, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteType = parseInt(ownprops.noteId.split("_")[0]);
    let pk = parseInt(ownprops.noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isFunctional = ownprops.isFunctional ? ownprops.isFunctional : false;
    let isWc = ownprops.isWc ? ownprops.isWc : false;
    let isSpeech = ownprops.isSpeech ? ownprops.isSpeech : false;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled ? true : false;

    let goalFavorites = Object.keys(state.entities.notes.PTGOALFAVORITES)
        .filter(key => {
            return (noteType === 1 && state.entities.notes.PTGOALFAVORITES[key].GFEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALFAVORITES[key].GFNTNO === pk)
        })
        .sort((a, b) => state.entities.notes.PTGOALFAVORITES[a].GFNAME.localeCompare(state.entities.notes.PTGOALFAVORITES[b].GFNAME))
        .map(key => state.entities.notes.PTGOALFAVORITES[key]);

    let disabled = noteType === 2 || noteType === 4 || noteType === 6 ||
        ((noteType === 3 || noteType === 5) && state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOGONO !== null) ? true : false;

    let masterGoals = Object.keys(state.entities.masterData.PTMASTERGOALS)
        .filter(x => {
            return (state.entities.masterData.PTMASTERGOALS[x].MGFUNCTIONAL === true && isFunctional && !isPeds && !isSpeech) ||
                (state.entities.masterData.PTMASTERGOALS[x].MGWORKCOMP === true && isWc && !isPeds && !isSpeech) ||
                (state.entities.masterData.PTMASTERGOALS[x].MGSPEECH === true && isSpeech && !isPeds) ||
                (state.entities.masterData.PTMASTERGOALS[x].MGPEDS === true && isPeds)
        })
        .sort((a, b) => state.entities.masterData.PTMASTERGOALS[a].MGORDER - state.entities.masterData.PTMASTERGOALS[b].MGORDER)
        .map(key => state.entities.masterData.PTMASTERGOALS[key]);

    masterGoals = Object.keys(masterGoals)
        .filter(x => masterGoals[x].MGNO !== parseInt(state.entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE))
        .map(x => masterGoals[x]);


    if (!state.entities.admissions[epno].allowFreeFormGoal) {
        // remove the freeform goal if its not allowed on this admission
        masterGoals = Object.keys(masterGoals)
            .filter(x => masterGoals[x].MGNO !== parseInt(state.entities.masterData.PROPS['PTERO_FREE_FORM_GOAL_ID'].PRVALUE))
            .map(x => masterGoals[x]);
    }

    if (ownprops.includeCustom !== undefined && ownprops.includeCustom === false) {
        masterGoals = Object.keys(masterGoals)
            .filter(x => masterGoals[x].MGNO !== parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE))
            .map(x => masterGoals[x]);
    }



    return {
        value: state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOMGNO ?
            state.entities.masterData.PTMASTERGOALS[state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOMGNO].MGNAME : undefined,
        customValue: state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOCUSTOM,
        maxLength: state.entities.masterData.PTERONOTESCHEMA['PTGOALS.GOCUSTOM'].CHARACTER_MAXIMUM_LENGTH,
        masterGoals,
        goalFavorites: goalFavorites,
        disabled,
        isCustom: state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID'].PRVALUE),
        isIndHep: state.entities.notes.PTGOALS[ownprops.entityKeyValue].GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE),
    };
}

const connectedGoalDropDown = connect(mapStateToProps, mapDispatchToProps)(GoalDropDown);
export { connectedGoalDropDown as GoalDropDown };